// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"24":"component---src-pages-impressum-tsx","245":"component---src-pages-index-tsx"}[chunkId] + "-" + {"24":"6921d9d65b76ffbaff4a","245":"162403124f5b77562bd1"}[chunkId] + ".js";
};